import type { RequestFunctionParams } from 'yapi-to-typescript';
import { zlb_request  } from '@zcy/zcy-request';
import { notification } from 'doraemon';
import { isEmpty } from 'lodash';

type ZcyRequestPayload = RequestFunctionParams & {
  params?: any;
}

type ZcyResponse = {
  success?: boolean;
  result?: any;
  code?: string;
  message?: string;
}

type Result<U extends ZcyResponse> = Pick<U, 'result'>['result'];

export default function request<T> (
  payload: ZcyRequestPayload,
  /**
   * 1. 不传：默认反馈
   * 2. 回调函数：自定义错误反馈
   * 3. 传false: 不需要反馈弹层
   **/ 
  errorCallback?: boolean | ((res: any) => void),
): Promise<Result<T>> {
  if(payload.method === 'GET') {
    payload.params = payload.data;
    // 修复query参数乱码
    if (isEmpty(payload.data)) {
      payload.data = undefined;
    }
  }
  
  return new Promise((resolve, reject) => {
    zlb_request(payload.path, payload)
      .then((res) => {
        const { success, result, message: _message } = (res || {}) as ZcyResponse ;
        if (!success) {
          // 错误反馈特殊处理
          typeof errorCallback === 'function' ? errorCallback(res) : 
            errorCallback !== false && notification.error({
              message: _message || '请求出错了',
            });
            
          reject(res);
        }
        resolve(result);
      })
      .catch((error) => {
        errorCallback !== false && notification.error({
          message: error?.data?.message || '请求出错了',
        });
        reject(error);
      });
  });
}
